/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectDocumentRequest
 */
export interface RejectDocumentRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * Business office only
     */
    reason: string;
    /**
     * Shown to the uploader as the item note
     */
    participant_rejection_reason?: string | null;
}

/**
 * Check if a given object implements the RejectDocumentRequest interface.
 */
export function instanceOfRejectDocumentRequest(value: object): value is RejectDocumentRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RejectDocumentRequestFromJSON(json: any): RejectDocumentRequest {
    return RejectDocumentRequestFromJSONTyped(json, false);
}

export function RejectDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'reason': json['reason'],
        'participant_rejection_reason': json['participant_rejection_reason'] === undefined ? undefined : json['participant_rejection_reason'] === null ? null : json['participant_rejection_reason'],
    };
}

export function RejectDocumentRequestToJSON(json: any): RejectDocumentRequest {
    return RejectDocumentRequestToJSONTyped(json, false);
}

export function RejectDocumentRequestToJSONTyped(value?: RejectDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'reason': value['reason'],
        'participant_rejection_reason': value['participant_rejection_reason'],
    };
}

